/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g id="Group_3512" data-name="Group 3512" transform="translate(-1144 -144)">
    <rect id="Rectangle_934" data-name="Rectangle 934" width="10" height="10" rx="2" transform="translate(1144 144)" fill="currentColor"/>
    <rect id="Rectangle_937" data-name="Rectangle 937" width="10" height="10" rx="2" transform="translate(1144 158)" fill="currentColor"/>
    <rect id="Rectangle_935" data-name="Rectangle 935" width="10" height="10" rx="2" transform="translate(1158 144)" fill="currentColor"/>
    <rect id="Rectangle_936" data-name="Rectangle 936" width="10" height="10" rx="2" transform="translate(1158 158)" fill="currentColor"/>
  </g>
</svg>
`

const LayoutThreeColumnSvg = (
  props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default LayoutThreeColumnSvg
